/**
 * Splits `array` into consecutive chunks of at most `size` items.
 *
 * Geotab searches have to be chunked before they are sent, both to stay under the per-call id
 * limits and to keep a single failing call from taking a whole fleet-sized request with it.
 *
 * @param array - The items to split.
 * @param size - The maximum number of items per chunk.
 */
export function chunkArray<T>(array: T[], size: number): T[][] {
  if (!Number.isFinite(size) || size < 1) {
    // A size of 0 would advance the loop by nothing and hang the tab. Callers derive the size
    // from limits and counts, so a computed 0 is reachable and must not be silently accepted.
    throw new RangeError(`chunkArray: size must be at least 1, received ${size}`);
  }

  const result: T[][] = [];
  for (let index = 0; index < array.length; index += size) {
    result.push(array.slice(index, index + size));
  }
  return result;
}
